export default __webpack_public_path__ + "static/og-765087e777b0d28e186b978073186c8d.png";